var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-section text-content"},[_c('div',{staticClass:"container"},_vm._l((_vm.items),function(item,index){return _c('div',{key:`item-${index}`,on:{"click":function($event){return _vm.highlightField('text')}}},[_c('div',{class:[
          'column',
          {'content-bg': _vm.parse(item).boxed},
          {'has-border': _vm.parse(item).column_borders}
        ],style:(_vm.columnStyle(_vm.parse(item))),domProps:{"innerHTML":_vm._s(_vm.parse(item).text)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }